import { Link } from "react-router-dom";
import { newsArticles } from "@/mocks/news";

export default function NewsPreview() {
  const latest = [...newsArticles]
    .sort((a, b) => b.publishedAt.localeCompare(a.publishedAt))
    .slice(0, 3);

  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="mb-5 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-extrabold text-foreground-950 md:text-2xl font-heading">
            <span className="h-5 w-1 rounded-full bg-accent-500 md:h-6"></span>
            影视资讯
          </h2>
          <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">
            行业动态、影评解读与最新发布，第一时间掌握影视圈风向
          </p>
        </div>
        <Link
          to="/news"
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200 md:text-sm"
        >
          更多资讯
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
        {latest.map((article) => (
          <Link
            key={article.id}
            to={`/news/${article.id}`}
            className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
          >
            <div className="h-40 w-full overflow-hidden bg-background-200 md:h-44">
              <img
                src={article.cover}
                alt={`${article.title}资讯配图`}
                title={`${article.title} - 久久爱影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-4">
              <div className="flex items-center gap-2 text-xs">
                <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
                  {article.category}
                </span>
                <span className="text-foreground-400">{article.publishedAt}</span>
              </div>
              <h3 className="mt-2 line-clamp-2 text-sm font-bold text-foreground-950 md:text-base">
                {article.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {article.summary}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}